const lt = {
    common: {
        appName: 'Ipsum City',
        productName: 'Turto ir gedimų valdymo sistema',
        home: 'Pradžia',
        back: 'Atgal',
        item: 'įrašas',
        items: 'įrašai',
        user: 'vartotojas',
        users: 'vartotojai',
        card: 'kortelė',
        cards: 'kortelės',
        task: 'užduotis',
        tasks: 'užduotys',
        language: 'Kalba',
        save: 'Išsaugoti',
        cancel: 'Atšaukti',
        search: 'Ieškoti',
        clear: 'Išvalyti',
        details: 'Išsami informacija',
        edit: 'Redaguoti',
        english: 'Anglų',
        lithuanian: 'Lietuvių',
        reset: 'Atstatyti',
        loading: 'Kraunama…',
        moreFilters: 'Daugiau filtrų',
        from: 'Nuo',
        to: 'Iki',
        rows: 'Eilutės',
        address: 'Adresas',
        description: 'Aprašymas',
        contractor: 'Rangovas',
        classification: 'Klasifikacija',
        district: 'Rajonas',
        category: 'Kategorija',
        subcategory: 'Pokategorė',
        location: 'Vieta',
        date: 'Data',
        type: 'Tipas',
        status: 'Būsena',
        total: 'Iš viso',
        today: 'šiandien',
        map: 'Žemėlapis',
        enlarge: 'Išdidinti',
        close: 'Uždaryti',
        fullscreen: 'Visas ekranas',
        exit: 'Išeiti',
        appearance: 'Išvaizda',
        created: 'Sukurta',
        completed: 'Užbaigta',
        select: 'Pasirinkti…',
        equipment: 'Įranga',
        export: 'Eksportuoti',
        importCsv: 'Importuoti CSV',
        importing: 'Importuojama...',
        browse: 'Naršyti',
        addNote: 'Pridėti pastabą',
        document: 'dokumentas',
        documents: 'dokumentai',
        unknownUser: 'Nežinomas vartotojas',
        entry: 'įrašas',
        entries: 'įrašai',
        required: 'Privaloma',
        invalidEmail: 'Neteisingas el. pašto adresas',
        invalidPassword: 'Neteisingas slaptažodis',
        passwordMin: 'Slaptažodis turi būti bent 8 simbolių',
        passwordMatch: 'Slaptažodžio patvirtinimas turi sutapti',
        record: 'įrašas',
        records: 'įrašai',
        site: 'Objektas'
    },
    status: {
        created: 'Sukurta',
        accepted: 'Priimta',
        started: 'Pradėta',
        wip: 'Vykdoma',
        completed: 'Užbaigta',
        urgent: 'Skubu'
    },
    display: {
        light: 'Šviesi',
        dark: 'Tamsi',
        wall: 'Siena',
        wallTitle: 'Sienos režimas dideliems ekranams'
    },
    time: {
        minutesShort: '{{n}} min',
        hoursShort: '{{n}} val.',
        daysShort: '{{n}} d.'
    },
    nav: {
        dashboard: 'Valdymo skydas',
        tasks: 'Užduotys',
        addTask: 'Pridėti užduotį',
        actives: 'Aktyvios',
        completed: 'Užbaigtos',
        taskBoard: 'Užduočių lenta',
        assets: 'Turtas',
        assetLocator: 'Turto lokatorius',
        costs: 'Išlaidos',
        preliminaries: 'Paruošiamieji darbai',
        costManager: 'Išlaidų valdymas',
        inventory: 'Inventorius',
        reports: 'Ataskaitos',
        monthlyReport: 'Mėnesio ataskaita',
        kpis: 'KPI',
        users: 'Vartotojai',
        addUser: 'Pridėti vartotoją',
        logout: 'Atsijungti',
        openMenu: 'Atidaryti meniu',
        closeMenu: 'Uždaryti meniu',
        expandMenu: 'Išskleisti meniu',
        collapseMenu: 'Sutraukti meniu',
        main: 'Pagrindinis'
    },
    login: {
        brandSubtitle: 'Prisijunkite, kad patektumėte į valdymo skydą',
        title: 'Prisijungti',
        subtitle: 'Įveskite prisijungimo duomenis, kad tęstumėte',
        email: 'El. paštas',
        password: 'Slaptažodis',
        emailPlaceholder: 'vardas@pavyzdys.com',
        passwordPlaceholder: 'Jūsų slaptažodis',
        showPassword: 'Rodyti slaptažodį',
        hidePassword: 'Slėpti slaptažodį',
        submit: 'Prisijungti',
        submitting: 'Jungiamasi…',
        confirmEmail: 'Patvirtinti el. paštą',
        forgotPassword: 'Pamiršote slaptažodį?',
        emailRequired: 'Įveskite el. pašto adresą.',
        emailInvalid: 'Įveskite galiojantį el. pašto adresą.',
        passwordRequired: 'Įveskite slaptažodį.',
        mfaSetupTitle: 'Nustatyti autentifikatorių',
        mfaVerifyTitle: 'Dviejų veiksnių patvirtinimas',
        mfaHintOptional: 'Neprivaloma: nuskaičiuokite QR kodą autentifikavimo programėle ir įveskite 6 skaitmenų kodą. Galite praleisti ir nustatyti vėliau.',
        mfaHintSetup: 'Reikalingas dviejų veiksnių patvirtinimas. Nuskaičiuokite QR kodą autentifikavimo programėle ir įveskite 6 skaitmenų kodą.',
        mfaHintSms: 'Įveskite kodą, atsiųstą SMS žinute.',
        mfaHintApp: 'Įveskite kodą iš autentifikavimo programėlės.',
        mfaPreparing: 'Ruošiamas QR kodas…',
        mfaSecretHint: 'Jei negalite nuskaičiuoti kodo, pridėkite paskyrą rankiniu būdu ir įveskite šį slaptąjį raktą:',
        authenticatorCode: 'Autentifikatoriaus kodas',
        verificationCode: 'Patvirtinimo kodas',
        completeSetup: 'Baigti nustatymą',
        verify: 'Patvirtinti',
        saving: 'Išsaugoma…',
        verifying: 'Tikrinama…',
        skipForNow: 'Praleisti dabar',
        backToLogin: 'Grįžti į prisijungimą',
        confirmEmailTitle: 'Patvirtinti el. paštą',
        confirmEmailHint: 'Įveskite el. paštą ir patvirtinimo kodą, kurį jums išsiuntėme.',
        confirmationCode: 'Patvirtinimo kodas',
        enterCode: 'Įveskite kodą',
        checkEmailCode: 'Patikrinkite el. paštą ir raskite kodą.',
        confirm: 'Patvirtinti',
        resetPasswordTitle: 'Atkurti slaptažodį',
        resetPasswordHint: 'Įveskite el. paštą, atkūrimo kodą ir naują slaptažodį.',
        resetCode: 'Atkūrimo kodas',
        askAdminCode: 'Paprašykite administratoriaus kodo.',
        newPassword: 'Naujas slaptažodis',
        newPasswordPlaceholder: 'Naujas slaptažodis',
        resetPassword: 'Atkurti slaptažodį',
        crestAlt: 'Herbas'
    },
    pages: {
        dashboard: {
            title: 'Valdymo skydas',
            subtitle: 'Užduočių, gedimų ir turto apžvalga'
        },
        kpis: {
            title: 'Pagrindiniai veiklos rodikliai',
            subtitle: 'Paslaugos, priežiūra, SLA ir išlaidos pasirinktam laikotarpiui',
            crumb: 'KPI'
        },
        tasksActive: {
            title: 'Aktyvios užduotys',
            subtitle: 'Valdykite ir stebėkite aktyvias užduotis'
        },
        tasksCompleted: {
            title: 'Užbaigtos užduotys',
            subtitle: 'Užbaigtos ir uždarytos užduotys'
        },
        taskBoard: {
            title: 'Užduočių lenta',
            subtitle: 'Šiandien vykdomi darbai',
            crumb: 'Lenta'
        },
        taskDetails: {
            title: 'Užduoties informacija',
            pageTitle: 'Užduotis {{ref}}'
        },
        taskAdd: {
            newTitle: 'Nauja užduotis',
            editTitle: 'Redaguoti užduotį',
            newSubtitle: 'Sukurti naują užduotį',
            editSubtitle: 'Atnaujinti užduoties duomenis',
            backToDetails: 'Užduoties informacija'
        },
        assets: {
            title: 'Turtas',
            subtitle: 'Objektai ir įranga'
        },
        assetLocator: {
            title: 'Turto lokatorius',
            subtitle: 'Raskite ir valdykite infrastruktūros turtą',
            crumb: 'Lokatorius',
            bridgeTitle: 'Tiltų įrenginių žemėlapis',
            bridgeCrumb: 'Tiltų įrenginiai'
        },
        assetDetails: {
            title: 'Turto informacija',
            pageTitle: 'Turtas {{ref}}',
            highPriority: 'Aukštas prioritetas',
            lowPriority: 'Žemas prioritetas'
        },
        assetAdd: {
            newTitle: 'Naujas turtas',
            editTitle: 'Redaguoti turtą'
        },
        costManager: {
            title: 'Išlaidų valdymas',
            subtitle: 'Užduočių išlaidos, medžiagos ir darbas'
        },
        preliminaries: {
            title: 'Paruošiamieji darbai',
            subtitle: 'Pastovūs mokesčiai ir kitos paruošiamosios išlaidos'
        },
        inventory: {
            title: 'Inventorius',
            subtitle: 'Atsargos ir tarifai'
        },
        monthlyReport: {
            title: 'Mėnesio ataskaita',
            subtitle: 'Užbaigtos ir vykdomos užduotys pasirinktam laikotarpiui'
        },
        users: {
            title: 'Vartotojai'
        },
        addUser: {
            title: 'Pridėti vartotoją'
        },
        editUser: {
            title: 'Redaguoti vartotoją',
            user: 'Vartotojas',
            subtitle: 'Valdykite vartotojo informaciją ir prieigos teises'
        }
    },
    dashboard: {
        operationsOverview: 'Operacijų apžvalga',
        live: 'TIESIOGIAI',
        waiting: 'LAUKIAMA',
        stale: 'PASENĘ',
        connectionLost: 'NĖRA RYŠIO',
        updated: 'Atnaujinta',
        time: 'Laikas',
        monitoredSites: 'Stebimi objektai',
        mapTasks: 'Žemėlapio užduotys',
        exitWall: 'Išeiti iš sienos režimo',
        tasksActive: 'Aktyvios užduotys',
        tasksCompleted: 'Užbaigtos užduotys',
        workInProgress: 'Vykdomi darbai',
        taskOutstanding: 'Neatliktos užduotys',
        last7days: 'Paskutinės 7 dienos',
        last30days: 'Paskutinės 30 dienų',
        activeLast7: 'Aktyvios · paskutinės 7 dienos',
        completedLast7: 'Užbaigtos · paskutinės 7 dienos',
        currentlyInProgress: 'Šiuo metu vykdoma',
        openOver7days: 'Atidaryta > 7 d.',
        createdToday: 'sukurta šiandien',
        completedToday: 'užbaigta šiandien',
        inProgressToday: 'vykdoma šiandien',
        overdueCount: '{{count}} pavėluota',
        oldestDays: 'seniausia {{days}} d.',
        taskMap: 'Užduočių žemėlapis',
        liveTaskMap: 'Tiesioginis užduočių žemėlapis',
        fitSites: 'Centruoti objektus',
        fitSitesTitle: 'Centruoti stebimus objektus',
        overview: 'Apžvalga',
        overviewTitle: 'Savivaldybės apžvalga',
        filterMarkers: 'Filtruoti žymeklius pagal būseną',
        closeMap: 'Uždaryti žemėlapį',
        enlargeMap: 'Išdidinti žemėlapį',
        incidents: 'Incidentai',
        urgentFaults: 'Skubūs gedimai',
        faultReports: 'Gedimų pranešimai',
        detectionDamage: 'Detekcijos pažeidimai',
        urgentReactive: 'Skubūs reaktyvūs',
        allReactive: 'Visos reaktyvios užduotys',
        detectorIssues: 'Detektorių / kilpų problemos · visos atviros ataskaitos',
        countToday: '{{count}} šiandien',
        countOpen: '{{count}} atidaryta',
        countUnassigned: '{{count}} nepriskirta',
        countOpenOver7: '{{count}} atidaryta > 7 d.',
        recentFaults: 'Naujausi gedimai',
        upcomingInspections: 'Artėjančios patikros',
        viewAll: 'Rodyti visus',
        noRecords: 'Nėra įrašų per paskutines 30 dienų',
        analyticsTitle: 'Aptarnavimo iškvietimai ir SLA analitika',
        analyticsSubtitle: 'Paskutinių 30 dienų kontekstas',
        serviceCalls: 'Aptarnavimo iškvietimai',
        serviceCallsReactive: 'Aptarnavimo iškvietimai – reaktyvi priežiūra',
        serviceCallsPpm: 'Aptarnavimo iškvietimai – prevencinė priežiūra',
        slaAttendance: 'SLA atvykimas',
        slaComplete: 'SLA užbaigtos užduotys',
        compliance: 'Atitiktis',
        nonCompliance: 'Neatitiktis',
        chartReactive: 'Reaktyvūs',
        chartPpmInspections: 'PPM patikros',
        chartPpmRoutine: 'PPM rutin. priežiūra',
        modalFaultReport: 'Gedimų ataskaita',
        modalUrgentFault: 'Skubus gedimas',
        modalLoopDamage: 'Kilpų / detekcijos pažeidimai',
        alertUrgentAgedOne: '{{count}} skubus gedimas atidarytas ilgiau nei 7 dienas',
        alertUrgentAgedMany: '{{count}} skubūs gedimai atidaryti ilgiau nei 7 dienas',
        alertSlaOne: '{{count}} užduotis viršija SLA atvykimą',
        alertSlaMany: '{{count}} užduotys viršija SLA atvykimą',
        alertUnassignedOne: '{{count}} skubus gedimas nepriskirtas',
        alertUnassignedMany: '{{count}} skubūs gedimai nepriskirti',
        showPin: 'Rodyti: {{label}}',
        hidePin: 'Slėpti: {{label}}'
    },
    tasks: {
        addTask: 'Pridėti užduotį',
        openTask: 'Atidaryti užduotį',
        allTasks: 'Visos užduotys',
        recentlyCreated: 'Neseniai sukurtos',
        assignedToMe: 'Priskirta man',
        sort: 'Rikiuoti',
        newestCreated: 'Naujausios',
        oldestCreated: 'Seniausios',
        urgency: 'Skubumas',
        slaAttend: 'SLA atvykimas',
        slaRepair: 'SLA remontas',
        slaAttendValue: 'SLA atvykimas {{contract}}',
        searchPlaceholder: 'Ieškoti pagal numerį, objektą, adresą ar aprašymą',
        taskRef: 'Užduoties nr.',
        siteRef: 'Objekto nr.',
        createdFrom: 'Sukurta nuo',
        createdTo: 'Sukurta iki',
        completedFrom: 'Užbaigta nuo',
        completedTo: 'Užbaigta iki',
        loading: 'Kraunamos užduotys...',
        emptyActive: 'Nėra aktyvių užduočių pagal šiuos filtrus.',
        emptyCompleted: 'Nėra užbaigtų užduočių pagal šiuos filtrus.',
        showing: 'Rodoma {{start}}–{{end}} iš {{total}} užduočių',
        legendActive: 'UŽDUOTIS · BŪSENA · OBJEKTAS · RAJONAS · KATEGORIJA · SUKURTA',
        legendCompleted: 'UŽDUOTIS · BŪSENA · OBJEKTAS · RAJONAS · KATEGORIJA · UŽBAIGTA',
        noDescription: 'Nėra aprašymo',
        expand: 'Išskleisti užduotį',
        collapse: 'Sutraukti užduotį',
        overdueBy: 'pavėluota {{duration}}',
        timeLeft: 'liko {{duration}}',
        quickFilters: 'Spartieji filtrai'
    },
    months: {
        january: 'sausis',
        february: 'vasaris',
        march: 'kovas',
        april: 'balandis',
        may: 'gegužė',
        june: 'birželis',
        july: 'liepa',
        august: 'rugpjūtis',
        september: 'rugsėjis',
        october: 'spalis',
        november: 'lapkritis',
        december: 'gruodis'
    },
    fields: {
        siteRef: 'Objekto nr.',
        siteAddress: 'Objekto adresas',
        siteLocation: 'Objekto vieta',
        siteReference: 'Objekto numeris',
        assetType: 'Turto tipas',
        prioritySite: 'Prioritetinis objektas',
        chargeCode: 'Apmokestinimo kodas',
        controller: 'Valdiklis',
        signalHead: 'Signalo galvutė',
        halogenLed: 'Halogenas/LED',
        pushButton: 'Mygtukas',
        elvLv: 'ELV/LV',
        operatingMode: 'Darbo režimas',
        tmrpn: 'TMRPN nr.',
        powerConsumption: 'Energijos suvartojimas (A/W)',
        billedConsumption: 'Apmokestinamas suvartojimas (W)',
        installationDate: 'Įrengimo data',
        upgradeDate: 'Atnaujinimo data',
        supplySource: 'Maitinimo šaltinis',
        specialCondition: 'Ypatinga sąlyga',
        makeModel: 'Gamintojas / modelis',
        signDisplay: 'Ženklo ekranas',
        installedBy: 'Įrengė',
        additionalInfo: 'Papildoma informacija',
        schoolName: 'Mokyklos pavadinimas',
        phoneNumber: 'Telefono numeris',
        schoolTimes: 'Mokyklos laikai',
        signSwitchOn: 'Ženklo įjungimas',
        signSwitchOff: 'Ženklo išjungimas',
        controllerLink: 'Valdiklio nuoroda',
        cameraLink: 'Kameros nuoroda',
        latitude: 'Platuma',
        longitude: 'Ilguma',
        categoryOfWork: 'Darbų kategorija',
        subCategory: 'Pokategorė',
        slaToAttend: 'SLA atvykimas',
        slaToComplete: 'SLA užbaigimas',
        slaComplete: 'SLA užbaigimas',
        chargeable: 'Apmokestinama',
        contractorRef: 'Rangovo nr.',
        jobNumber: 'Darbo numeris',
        invoiceDate: 'Sąskaitos data',
        invoiceNumber: 'Sąskaitos numeris',
        workRequired: 'Reikalingi darbai',
        contractorDetails: 'Rangovo duomenys',
        siteDetails: 'Objekto duomenys',
        equipmentDetails: 'Įrangos duomenys',
        technicalInfo: 'Techninė informacija',
        schoolDetails: 'Mokyklos duomenys',
        taskInformation: 'Užduoties informacija',
        materials: 'Medžiagos',
        callOutFee: 'Iškvietimo mokestis',
        onSiteLabour: 'Darbas objekte',
        totalCost: 'Bendra kaina',
        materialsTotal: 'Medžiagų suma',
        searchMaterial: 'Ieškoti medžiagos',
        qty: 'Kiekis',
        rate: 'Tarifas',
        subtotal: 'Tarpinė suma',
        itemId: 'Prekės ID',
        nr: 'Nr.',
        note: 'Pastaba',
        image: 'Paveikslėlis',
        file: 'Failas',
        filename: 'Failo pavadinimas',
        version: 'Versija',
        lastUpdate: 'Paskutinis atnaujinimas',
        name: 'Vardas',
        email: 'El. paštas',
        admin: 'Admin',
        administrator: 'Administratorius',
        enabled: 'Įjungtas',
        disabled: 'Išjungtas',
        verified: 'Patvirtintas',
        updated: 'Atnaujinta',
        confirmPassword: 'Patvirtinti slaptažodį',
        applicationAccess: 'Programos prieiga',
        routineInspection: 'Periodinė patikra',
        problem: 'Problema',
        na: 'N/A',
        scheduled: 'Suplanuota',
        fixed: 'Fiksuota',
        quoted: 'Pasiūlyta',
        reference: 'Nuoroda',
        amount: 'Suma',
        calculatedTotal: 'Apskaičiuota suma',
        workCarriedOut: 'Atlikti darbai',
        callOut: 'Iškvietimas',
        gpsCoordinates: 'GPS koordinatės',
        remoteAccess: 'Nuotolinė prieiga',
        supplyGps: 'Maitinimo GPS koordinatės',
        siteAndPriority: 'Objektas ir prioritetas',
        workClassificationSla: 'Darbų klasifikacija ir SLA',
        docNo: 'Dok. nr.'
    },
    actions: {
        add: 'Pridėti',
        addAsset: 'Pridėti turtą',
        addUser: 'Pridėti vartotoją',
        addItem: 'Pridėti prekę',
        addCost: 'Pridėti išlaidą',
        addCard: 'Pridėti kortelę',
        addList: 'Pridėti sąrašą',
        addLane: 'Pridėti',
        openAsset: 'Atidaryti turtą',
        editTask: 'Redaguoti užduotį',
        complete: 'Užbaigti',
        moveToWip: 'Perkelti į vykdomas',
        moveToCompleted: 'Perkelti į užbaigtas',
        completing: 'Užbaigiama…',
        delete: 'Ištrinti',
        save: 'Išsaugoti',
        clear: 'Išvalyti',
        copy: 'Kopijuoti',
        viewQr: 'Rodyti QR',
        download: 'Atsisiųsti',
        apply: 'Ieškoti',
        filters: 'Filtrai',
        notes: 'Pastabos',
        documents: 'Dokumentai',
        details: 'Išsami informacija',
        camera: 'Kamera',
        googleMaps: '„Google“ žemėlapiai'
    },
    assets: {
        countLabel: 'turtas',
        searchPlaceholder: 'Ieškoti pagal objektą, adresą, tipą ar kodą',
        loading: 'Kraunamas turtas...',
        empty: 'Nėra turto pagal šiuos filtrus.',
        showing: 'Rodoma {{start}}–{{end}} iš {{total}} turto',
        legend: 'OBJEKTAS · TIPAS · ADRESAS · RAJONAS · VALDIKLIS · GALVUTĖS',
        noAddress: 'Nėra adreso',
        priority: 'Prioritetas',
        prioritySite: 'Prioritetinis objektas',
        expand: 'Išskleisti turtą',
        collapse: 'Sutraukti turtą',
        deleteTitle: 'Ištrinti turtą',
        deleteConfirm: 'Patvirtinkite, kad tikrai norite ištrinti šį turtą',
        deleted: 'Turtas ištrintas',
        deleteError: 'Klaida trinant turtą',
        loadingAsset: 'Kraunamas turtas…',
        noGps: 'Nėra GPS koordinačių',
        noGpsHint: 'Šis turtas dar neturi vietos žemėlapyje.',
        qrTitle: 'Turto QR',
        high: 'Aukštas',
        low: 'Žemas',
        noTasks: 'Šiam turtui dar nėra užduočių.'
    },
    locator: {
        filters: 'Filtrai',
        allDistricts: 'Visi rajonai',
        allTypes: 'Visi tipai',
        allSigns: 'Visi ženklai',
        highPriority: 'Aukštas prioritetas',
        noMapLocation: 'Nėra vietos žemėlapyje',
        mapLegend: 'Žemėlapio legenda',
        assetTypes: 'Turto tipai',
        showLess: 'Rodyti mažiau',
        showAll: 'Rodyti visus',
        loading: 'Kraunamas turtas...',
        pleaseWait: 'Palaukite, kol gausime duomenis',
        retryLater: 'Atnaujinkite puslapį arba bandykite vėliau',
        results: '{{count}} rezultatai',
        sortBy: 'Rikiuoti pagal',
        siteAz: 'Objekto nr. A–Z',
        siteZa: 'Objekto nr. Z–A',
        sortType: 'Turto tipas',
        noRecords: 'Įrašų nerasta',
        tryFilters: 'Pabandykite pakeisti filtrus',
        openAsset: 'Atidaryti {{ref}}',
        resizeList: 'Keisti sąrašo plotį',
        showList: 'Rodyti turto sąrašą',
        expandMap: 'Išdidinti žemėlapį',
        other: 'Kita'
    },
    kpis: {
        year: 'Metai',
        month: 'Mėnuo',
        serviceCalls: 'Aptarnavimo iškvietimai',
        pendingHint: '{{count}} laukia',
        noCreated: 'Nėra sukurtų užduočių',
        ofCreated: '{{pct}} nuo sukurtų',
        slaAttendance: 'SLA atvykimas',
        slaCompletion: 'SLA užbaigimas',
        slaOnTimeHint: '{{ok}} iš {{total}} užbaigtų užduočių laiku',
        noSla: 'Nėra užbaigtų užduočių su SLA',
        annualSpend: 'Metinės išlaidos',
        yearToDate: '{{year}} metai iki šiol',
        createdVsCompleted: 'Sukurta ir užbaigta',
        created: 'Sukurta',
        done: 'Atlikta',
        pending: 'Laukia',
        maintenance: 'Priežiūra',
        maintenanceNote: 'Reaktyvūs {{reactive}} · PPM {{created}} sukurta, {{completed}} užbaigta, {{pending}} laukia',
        reactiveByFault: 'Reaktyvūs pagal gedimą',
        sortedByVolume: 'Rikiuota pagal apimtį',
        preventative: 'Prevencinė priežiūra',
        inspectionsRoutine: 'Patikros ir rutiniai darbai',
        fault: 'Gedimas',
        slaPerformance: 'SLA rezultatai',
        slaNote: 'Rodikliai naudoja {{month}} užbaigtas užduotis, kurios jau turi atvykimo ar remonto laiką.',
        onTime: 'Laiku',
        late: 'Vėluoja',
        rate: 'Rodiklis',
        spendTitle: 'Išlaidos {{year}}',
        breakdown: 'Išskaidymas'
    },
    users: {
        addUser: 'Pridėti vartotoją',
        search: 'Ieškoti…',
        clearFilters: 'Išvalyti visus filtrus',
        noRecords: 'Įrašų nerasta',
        tryFilters: 'Pabandykite pakeisti arba išvalyti filtrus',
        loading: 'Kraunami vartotojai...',
        pleaseWait: 'Palaukite, kol gausime duomenis',
        yes: 'Taip',
        no: 'Ne',
        emailVerified: 'El. paštas patvirtintas',
        clickVerify: 'Spustelėkite, kad patvirtintumėte el. paštą',
        validPassword: 'Įveskite tinkamą slaptažodį',
        confirmEmail: 'Patvirtinti el. paštą',
        verifyEmail: 'Patvirtinti el. paštą',
        emailIsVerified: 'El. paštas patvirtintas',
        emailVerifiedBtn: 'El. paštas patvirtintas',
        disableUser: 'Išjungti vartotoją',
        enableUser: 'Įjungti vartotoją',
        markVerified: 'Pažymėti el. paštą kaip patvirtintą',
        pwdAtLeast: 'bent 8 simboliai',
        pwdCase: 'didžiosios ir mažosios raidės',
        pwdNumber: 'bent vienas skaičius',
        pwdSpecial: 'bent vienas specialusis simbolis',
        createSubtitle: 'Sukurkite naują vartotoją su prieigos teisėmis'
    },
    costsUi: {
        addCost: 'Pridėti išlaidą',
        enterDescription: 'Įveskite aprašymą…',
        costEuro: 'Kaina (€)',
        noCosts: 'Išlaidų nerasta',
        addHint: 'Pridėkite paruošiamąją išlaidą forma aukščiau',
        loading: 'Kraunamos išlaidos...',
        pleaseWait: 'Palaukite, kol gausime duomenis',
        deleteTitle: 'Ištrinti išlaidą',
        addItem: 'Pridėti prekę',
        itemIdOptional: 'Prekės ID (neprivaloma)',
        autoId: 'Jei tuščia, sugeneruojama automatiškai',
        itemDescription: 'Prekės aprašymas',
        rateEuro: 'Tarifas (€)',
        materialsList: 'Medžiagų sąrašas',
        searchItems: 'Ieškoti pagal prekės ID arba aprašymą…',
        loadingInv: 'Kraunamas inventorius...',
        noItems: 'Nėra inventoriaus prekių',
        trySearch: 'Pabandykite pakeisti arba išvalyti paiešką',
        addOrImport: 'Pridėkite prekę aukščiau arba importuokite CSV',
        updatedAt: 'Atnaujinta',
        actions: 'Veiksmai',
        editItem: 'Redaguoti inventoriaus prekę',
        deleteItem: 'Ištrinti inventoriaus prekę',
        importReport: 'Inventoriaus importo ataskaita',
        totalRows: 'Iš viso eilučių',
        processed: 'Apdorota',
        skipped: 'Praleista',
        overwritten: 'Perrašyta',
        duplicates: 'Dublikatai faile',
        row: 'Eilutė',
        reason: 'Priežastis',
        deleteConfirm: 'Patvirtinkite, kad norite ištrinti šią išlaidą:',
        importingFile: 'Importuojamas failas ir atnaujinamos medžiagos...',
        csvColumns: 'CSV stulpeliai: Prekės ID, Aprašymas, Tarifas',
        rateHint: 'Tarifas priima 12.50, 1,200.00, 1.200,00 arba reikšmes su € / $ simboliais.',
        showingSorted: 'Rodoma {{shown}} iš {{total}} prekių, rikiuota pagal prekės ID',
        deleteConfirmItem: 'Patvirtinkite ištrynimą:',
        rowsFailed: 'Šių eilučių nepavyko pridėti:',
        allProcessed: 'Visos tinkamos eilutės apdorotos. Perrašytos eilutės nerodomos, nes jos sėkmingai atnaujintos.',
        clearSearch: 'Išvalyti paiešką',
        enterAmount: 'Įveskite sumą',
        edited: 'Redaguota',
        totalCosts: 'Iš viso išlaidų',
        restoreValues: 'Atkurti išsaugotas šios užduoties reikšmes'
    },
    board: {
        addList: 'Pridėti sąrašą',
        addCard: 'Pridėti kortelę',
        archiveList: 'Archyvuoti sąrašą',
        listName: 'Sąrašo pavadinimas',
        needsAttention: 'Kam reikia dėmesio',
        chooseTask: 'Pasirinkti užduotį',
        colour: 'Spalva',
        dragHint: 'Vilkite stulpelį, kad pakeistumėte tvarką',
        deleteList: 'Ištrinti sąrašą',
        noCards: 'Šiame sąraše nėra kortelių',
        addLane: 'Pridėti',
        rename: 'Pervadinti',
        editNote: 'Redaguoti pastabą'
    },
    report: {
        loadingCosts: 'Kraunamos išlaidos…',
        loading: 'Kraunama ataskaita...',
        empty: 'Nėra užduočių pagal šiuos filtrus. Pakeiskite juos ir spauskite Ieškoti.',
        exportFilter: 'Eksporto filtras',
        invoiced: 'Išrašyta sąskaita',
        notInvoiced: 'Neišrašyta sąskaita',
        completedWip: 'Užbaigta + vykdoma'
    },
    taskForm: {
        save: 'Išsaugoti',
        searchMaterial: 'Ieškoti pagal prekės ID arba aprašymą',
        noMaterials: 'Medžiagų nepasirinkta',
        problemDescription: 'Problemos aprašymas (jei yra)'
    },
    taskView: {
        deleteTitle: 'Ištrinti užduotį',
        deleteConfirm: 'Patvirtinkite, kad tikrai norite ištrinti šią užduotį',
        wipTitle: 'Perkelti užduotį į vykdomas',
        wipHint: 'Nurodykite priežastį, kodėl užbaigta užduotis grąžinama į vykdomas:',
        wipPlaceholder: 'Įveskite priežastį…',
        completeTitle: 'Perkelti užduotį į užbaigtas',
        completeHint: 'Įveskite atliktų darbų aprašymą. Periodinė patikra bus išsaugota kaip viskas gerai.',
        completePlaceholder: 'pvz. uždarė administratorius',
        siteHistory: 'Objekto istorija',
        noHistory: 'Istorijos dar nėra',
        noHistoryHint: 'Čia atsiras šio objekto pastabos',
        invoice: 'Sąskaita',
        taskCompleted: 'Užduotis užbaigta',
        taskStarted: 'Užduotis pradėta',
        taskAccepted: 'Užduotis priimta',
        workDone: 'Darbai atlikti',
        inspectionIssue: 'Patikros problema',
        faultReported: 'Praneštas gedimas',
        movedToWip: 'Perkelta į vykdomas'
    },
    docs: {
        upload: 'Įkelti dokumentą',
        deleteTitle: 'Ištrinti dokumentą',
        deleteConfirm: 'Patvirtinkite, kad tikrai norite ištrinti dokumentą numeris {{n}}',
        editTitle: 'Redaguoti dokumentą',
        doc: 'Dok.',
        none: 'Šiam turtui dokumentų neįkelta.',
        invalidFile: 'Netinkamas failas'
    },
    toast: {
        coordsCopied: 'Koordinatės nukopijuotos',
        coordsCopyFail: 'Nepavyko nukopijuoti koordinačių',
        assetSaved: 'Turtas išsaugotas',
        errorSavingAsset: 'Klaida išsaugant turtą',
        errorLoadingInventory: 'Klaida kraunant inventorių',
        errorLoadingAssets: 'Klaida kraunant turtą',
        taskSaved: 'Užduotis išsaugota',
        errorSavingTask: 'Klaida išsaugant užduotį',
        totalCostZero: 'Bendra kaina yra nulis (0)',
        documentSaved: 'Dokumentas išsaugotas',
        errorSavingDocument: 'Klaida išsaugant dokumentą',
        documentDeleted: 'Dokumentas ištrintas',
        errorDeletingDocument: 'Klaida trinant dokumentą',
        errorEditingDocument: 'Klaida redaguojant dokumentą',
        errorLoadingTasks: 'Klaida kraunant užduotis',
        errorLoadingUsers: 'Klaida kraunant vartotojus',
        noteSaved: 'Pastaba išsaugota',
        errorSavingNote: 'Klaida išsaugant pastabą',
        costSaved: 'Išlaida išsaugota',
        errorSavingCost: 'Klaida išsaugant išlaidą',
        costDeleted: 'Išlaida ištrinta',
        errorDeletingCost: 'Klaida trinant išlaidą',
        descriptionRequired: 'Aprašymas privalomas',
        rateMustBeNumber: 'Tarifas turi būti skaičius',
        inventoryAdded: 'Inventoriaus prekė pridėta',
        errorAddingInventory: 'Klaida pridedant inventoriaus prekę',
        inventoryUpdated: 'Inventoriaus prekė atnaujinta',
        errorUpdatingInventory: 'Klaida atnaujinant inventoriaus prekę',
        inventoryDeleted: 'Inventoriaus prekė ištrinta',
        errorDeletingInventory: 'Klaida trinant inventoriaus prekę ({{id}})',
        importFinished: 'Importas baigtas: apdorota {{n}} prekė(-ės)',
        errorImportingCsv: 'Klaida importuojant CSV',
        errorSavingBoard: 'Klaida išsaugant lentą',
        userExists: 'Vartotojas jau egzistuoja',
        userCreatedUnverified: 'Vartotojas sukurtas, bet el. pašto nepavyko patvirtinti',
        userSaved: 'Vartotojas išsaugotas',
        errorSavingUser: 'Klaida išsaugant vartotoją',
        userDisabled: 'Vartotojas išjungtas',
        errorDisablingUser: 'Klaida išjungiant vartotoją',
        userEnabled: 'Vartotojas įjungtas',
        errorEnablingUser: 'Klaida įjungiant vartotoją',
        emailVerified: 'El. paštas patvirtintas',
        errorVerifyingEmail: 'Klaida patvirtinant el. paštą',
        passwordResetSent: 'Slaptažodžio atkūrimo kodas išsiųstas',
        emailVerifiedFor: 'El. paštas patvirtintas: {{user}}',
        errorLoadingTask: 'Klaida kraunant užduotį',
        taskNotLoaded: 'Užduoties duomenys neįkelti',
        onlyCompletedToWip: 'Į vykdomas galima perkelti tik užbaigtas užduotis',
        wipReasonRequired: 'Nurodykite priežastį, kodėl užduotis perkeliama į vykdomas',
        taskMovedToWip: 'Užduotis perkelta į vykdomas',
        errorMovingToWip: 'Klaida perkeliant užduotį į vykdomas',
        noCurrentUser: 'Nepavyko gauti dabartinio vartotojo',
        onlyAdminsComplete: 'Tik administratoriai gali perkelti užduotis į užbaigtas',
        onlyActiveToCompleted: 'Į užbaigtas galima perkelti tik aktyvias užduotis',
        workDoneRequired: 'Įveskite atliktų darbų aprašymą',
        taskMovedToCompleted: 'Užduotis perkelta į užbaigtas',
        errorMovingToCompleted: 'Klaida perkeliant užduotį į užbaigtas',
        errorDeletingTaskLog: 'Klaida trinant užduoties žurnalą',
        taskDeleted: 'Užduotis ištrinta',
        errorDeletingTask: 'Klaida trinant užduotį'
    },
    modal: {
        lastUpdate: 'Paskutinis atnaujinimas',
        viewDetails: 'Peržiūrėti'
    },
    exportDoc: {
        pdf: 'PDF',
        exportExcel: 'Eksportuoti į Excel',
        monthlyReport: 'Mėnesio ataskaita',
        dateFrom: 'Data nuo',
        to: 'iki',
        none: 'Nėra',
        taskRef: 'Užduoties nr.',
        municipalDistrict: 'Savivaldybės rajonas',
        dateCreated: 'Sukūrimo data',
        user: 'Vartotojas',
        contractRequirements: 'Sutarties reikalavimai',
        slaAttendSite: 'SLA atvykimas',
        slaCompleteTask: 'SLA užbaigimas',
        engineer: 'Inžinierius',
        taskStatus: 'Užduoties būsena',
        dateAccepted: 'Priėmimo data',
        dateStarted: 'Pradžios data',
        dateCompleted: 'Užbaigimo data',
        attendSite: 'Atvykimas',
        completeTask: 'Užbaigimas',
        typeFault: 'Gedimo tipas',
        faultDescription: 'Gedimo aprašymas',
        number: 'Skaičius',
        onSiteLabourCost: 'Darbo objekte kaina',
        dayTime: '{{n}} d., {{time}}',
        daysTime: '{{n}} d., {{time}}',
        detailsOfWorks: 'Reikalingų darbų duomenys',
        costs: 'Išlaidos',
        progress: 'Eiga',
        costCode: 'Išlaidų kodas',
        contractorJobRef: 'Rangovo darbo numeris',
        descriptionOfFault: 'Gedimo aprašymas',
        descriptionOfWork: 'Atliktų darbų aprašymas',
        typeOfFault: 'Gedimo tipas',
        callOutNo: 'Iškvietimų sk.',
        callOutRate: 'Iškvietimo tarifas',
        callOutSubtotal: 'Iškvietimo suma',
        onsiteNo: 'Obj. sk.',
        onSiteRate: 'Obj. tarifas',
        onSiteSubtotal: 'Obj. suma',
        dateContractorAttended: 'Rangovo atvykimo data',
        hpSite: 'Prioritetinis',
        urgent: 'Skubu',
        slaAttend: 'SLA atvykimas'
    },
    notFound: {
        title: 'Puslapis nerastas',
        message: 'Atsiprašome, puslapis nerastas!',
        hint: 'Puslapis, kurio ieškote, neegzistuoja arba buvo perkeltas.',
        goBack: 'Grįžti'
    },
    ri: {
        lampsFault: 'Lempų gedimas',
        signalHeads: 'Signalo galvučių lygiavimas ir tvirtinimas',
        poleCaps: 'Stulpų dangteliai ir kamščiai',
        pushButtons: 'Mygtukai',
        controllers: 'Valdikliai',
        detection: 'Visa detekcija veikia',
        logBook: 'Žurnalas',
        siteIssues: 'Objekto problemos',
        doorClosed: 'Durys uždarytos'
    },
    catalog: {
        'Fibre Optic': 'Šviesolaidis',
        'Pedestrian Crossing': 'Pėsčiųjų perėja',
        'Pelican Crossing': 'Pelican perėja',
        'School Warning Sign': 'Mokyklos įspėjamasis ženklas',
        'Signalised Junction': 'Reguliuojama sankryža',
        'Toucan Crossing': 'Toucan perėja',
        'Zebra Crossing': 'Zebrinė perėja',
        'Sign - Other': 'Ženklas – kita',
        'CCTV': 'Vaizdo stebėjimas',
        'Design & Construction': 'Projektavimas ir statyba',
        'Periodic Speed Limit Sign': 'Periodinio greičio ženklas',
        'Public Lighting': 'Viešasis apšvietimas',
        'Other': 'Kita',
        'Puffin Crossing': 'Puffin perėja',
        'Driver Feedback Sign': 'Vairuotojo grįžtamojo ryšio ženklas',
        'Electronic Speed Warning Sign': 'Elektroninis greičio įspėjamasis ženklas',
        'Reactive': 'Reaktyvi',
        'Reactive Maintenance': 'Reaktyvi priežiūra',
        'PPM': 'PPM',
        'Planned Preventative Maintenance (PPM)': 'Planinė prevencinė priežiūra (PPM)',
        'Switch off / on': 'Išjungimas / įjungimas',
        'Switch off/on': 'Išjungimas/įjungimas',
        'Upgrade': 'Atnaujinimas',
        'Upgrades': 'Atnaujinimai',
        'Signs': 'Ženklai',
        'Projects': 'Projektai',
        'Technical Support': 'Techninė pagalba',
        'Inspection Request': 'Patikros užklausa',
        'Urgent': 'Skubu',
        'Non-Urgent': 'Neskubu',
        'Scheduled': 'Suplanuota',
        'Fixed': 'Fiksuota',
        'Quoted': 'Pasiūlyta',
        'Chargeable': 'Apmokestinama',
        'hrs': 'val.',
        'days': 'd.',
        'Controller Fault': 'Valdiklio gedimas',
        'Detector Fault': 'Detektoriaus gedimas',
        'PBU Fault': 'PBU gedimas',
        'Electrical Fault': 'Elektros gedimas',
        'Lamp Fault': 'Lempos gedimas',
        'Comms Fault': 'Ryšio gedimas',
        'Sign Fault': 'Ženklo gedimas',
        'Knockdown': 'Numušimas',
        'Twisted Head': 'Pasukta galvutė',
        'Graffiti': 'Grafitis',
        'Check Operation and Detection': 'Patikrinti veikimą ir detekciją',
        'Lights Out': 'Šviesos neveikia',
        'Vandalism': 'Vandalizmas',
        'ESB power Cut': 'ESB elektros nutrūkimas',
        'Vehicle strike': 'Transporto priemonės smūgis',
        'Twisted signal head': 'Pasukta signalo galvutė',
        'Periodic Inspection': 'Periodinė patikra',
        'Periodic Inspection Report': 'Periodinės patikros ataskaita',
        'Annual Inspection (Signals)': 'Metinė patikra (signalai)',
        'Annual Inspection (Structures)': 'Metinė patikra (konstrukcijos)',
        'Annual Inspection (Signs)': 'Metinė patikra (ženklai)',
        'Annual Inspection Report': 'Metinės patikros ataskaita',
        'Routine Maintenance': 'Rutinė priežiūra',
        'Non LED Lamp replacement': 'Ne LED lempų keitimas',
        'Utility Contractor': 'Komunalinių paslaugų rangovas',
        'Resurfacing contractor': 'Dangos atnaujinimo rangovas',
        'N/A': 'N/A',
        'Refurbishment': 'Renovacija',
        'New installation': 'Naujas įrengimas',
        'Works Order': 'Darbų užsakymas',
        'Design Review': 'Projekto peržiūra',
        'Contract Document Review': 'Sutarties dokumentų peržiūra',
        'Preliminary Design': 'Preliminarus projektas',
        'Detailed Design': 'Detalusis projektas',
        'Material Approval': 'Medžiagų patvirtinimas',
        'Site Inspection': 'Objekto patikra',
        'Technical Report': 'Techninė ataskaita',
        'Techical Advice': 'Techninė konsultacija',
        'Snagging': 'Trūkumų šalinimas',
        'Correspondance': 'Korespondencija',
        'Pre Connection Snag': 'Trūkumai prieš prijungimą',
        'Post Connection Snag': 'Trūkumai po prijungimo',
        'Technical advice': 'Techninė konsultacija',
        'SCATs': 'SCATs',
        'Comms': 'Ryšys',
        'Lighting Design': 'Apšvietimo projektas',
        'Inspection': 'Patikra',
        'Periodic Insp': 'Period. patikra',
        'Annual Insp (Sig)': 'Met. patikra (sig.)',
        'Annual Insp (Struc)': 'Met. patikra (konstr.)',
        'Annual Insp (Signs)': 'Met. patikra (ženk.)',
        'Routine Maint': 'Rutinė priežiūra',
        'Non LED Lamp rep': 'Ne LED lempų keit.',
        'Non-LED Lamp': 'Ne LED lempos',
        'PPM Inspections': 'PPM patikros',
        'PPM Routine Maint': 'PPM rutinė priežiūra',
        'Materials': 'Medžiagos',
        'Preliminaries': 'Paruošiamieji darbai'
    }
};

export default lt;
